import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../lib/auth';
import { getEligibilityDate, getEffectiveLegalAge } from '../../../utils/utilsParking';
import { ParkingType } from '../../../utils/utilTypes';

type Props = {
  parking: ParkingType;
};

export const AgeRestrictionPopup = ({ parking }: Props) => {
  const { t } = useTranslation();
  const { currentUser } = useAuth();
  const minAge = getEffectiveLegalAge(parking);

  const eligibilityDateStr =
    currentUser?.dateOfBirth && minAge != null
      ? getEligibilityDate(currentUser.dateOfBirth, minAge)
      : null;

  return (
    <div className="absolute bg-white z-status-popup left-[36px] right-[36px] top-[32px] shadow-lg flex flex-col p-6">
      <div className="text-lg text-center text-danger font-bold">
        {t('ageRestrictionPopup.title')}
      </div>
      <div className="my-4 text-sm text-center">
        {t('ageRestrictionPopup.body', { age: minAge })}
      </div>
      {eligibilityDateStr && (
        <div className="text-xs text-center text-gray-500">
          {t('ageRestrictionPopup.eligibility', { date: eligibilityDateStr, interpolation: { escapeValue: false } })}
        </div>
      )}
    </div>
  );
};
